/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CarpsaleManagementListItemResponse } from './CarpsaleManagementListItemResponse';

export type CarpsaleManagementListItemResponseApiRespoonse = {
    data?: CarpsaleManagementListItemResponse;
    status?: CarpsaleManagementListItemResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace CarpsaleManagementListItemResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

